import { useEffect } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { LensProduct, OrderClItem } from '../types';

type UseSelectedProductParams = {
  products: LensProduct[];
  productId: number | undefined;
  rightLens: OrderClItem;
  leftLens: OrderClItem;
  setQtyMax: Dispatch<SetStateAction<number>>;
  setIsAstigma: Dispatch<SetStateAction<boolean>>;
  setRestrict: Dispatch<SetStateAction<string | undefined>>;
  setRightLens: Dispatch<SetStateAction<OrderClItem>>;
  setLeftLens: Dispatch<SetStateAction<OrderClItem>>;
  setProductName: Dispatch<SetStateAction<string | undefined>>;
  setIsRightLensOrdered: Dispatch<SetStateAction<boolean>>;
  setIsLeftLensOrdered: Dispatch<SetStateAction<boolean>>;
};

const useSelectedProduct = ({
  products,
  productId,
  rightLens,
  leftLens,
  setQtyMax,
  setIsAstigma,
  setRestrict,
  setRightLens,
  setLeftLens,
  setProductName,
  setIsRightLensOrdered,
  setIsLeftLensOrdered,
}: UseSelectedProductParams): void => {

  useEffect(() => {
    if (productId !== undefined && products.length > 0) {
      const selectedProduct = products.find(product => product.id === productId);
      setQtyMax(0);
      setIsAstigma(false);
      setRestrict(undefined);
      setRightLens({fc: undefined, tp: undefined, cyl: undefined, dia: undefined, qty: 1, eyeType: "right", productId: undefined});
      setLeftLens({fc: undefined, tp: undefined, cyl: undefined, dia: undefined, qty: 1, eyeType: "left", productId: undefined});

      if (selectedProduct) {
        setProductName(selectedProduct.name);
        setQtyMax(selectedProduct.qtyMax);
        setIsAstigma(selectedProduct.lensType === "astigma");
        setRestrict(selectedProduct.restrict);

        if(selectedProduct.restrict === 'only_right') {
          setIsRightLensOrdered(true);
          setIsLeftLensOrdered(false);
        }
        if(selectedProduct.restrict === 'only_left') {
          setIsLeftLensOrdered(true);
          setIsRightLensOrdered(false);
        }
        if(selectedProduct.restrict === 'no_restrict') {
          const storedIsRightLensOrdered = localStorage.getItem("isRightLensOrdered");
          if(storedIsRightLensOrdered) {
            setIsRightLensOrdered(JSON.parse(storedIsRightLensOrdered));
          } else {
            setIsRightLensOrdered(true);
          }
          const storedIsLeftLensOrdered = localStorage.getItem("isLeftLensOrdered");
          if(storedIsLeftLensOrdered) {
            setIsLeftLensOrdered(JSON.parse(storedIsLeftLensOrdered));
          } else {
            setIsLeftLensOrdered(true);
          }
        }

        setRightLens({...rightLens, productId: productId});
        setLeftLens({...leftLens, productId: productId});
      }
    }
  }, [productId, products]);
};

export default useSelectedProduct;